export default __webpack_public_path__ + "static/media/2 BHK - 1234.25 -3D.e2c3fdb8.png";